// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2YJPe","inner":"Footer_inner__ytJw0"};